(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'integerControl',
            [
                'CHROME',
                IntegerControlFactory
            ]
        );

    // Factory Method
    function IntegerControlFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.PROJECT.CONTROL.INTEGER + CHROME.POSTFIX
        };

    }
})();



